// extracted by mini-css-extract-plugin
export default {"petitionSection":"CampaignPetitionSections_petitionSection__fTJjv","petitionSectionBackground":"CampaignPetitionSections_petitionSectionBackground__CbUMY"};